module.exports = __webpack_public_path__ + "static/media/gdpr.358bd6fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gdpr.svg
// module id = 949
// module chunks = 5